// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2NvbC","head":"Table_head__SfIm1","col":"Table_col__3VirK"};